export const addHeadingIds = (html: string): string => {
    const headingRegex = /<h([1-6])(.*?)>([\s\S]*?)<\/h\1>/g;
    let sectionNumber = 1;

    const modifiedHtml = html.replace(
        headingRegex,
        (match, p1, p2, p3) => {
            const labelContent = p3.trim().replace(/"/g, '&quot;');
            return `<h${p1} id="section-${sectionNumber++}"${p2} label="${labelContent}">${p3}</h${p1}>`;
        }
    );

    return modifiedHtml;
};
